var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobTracerPilot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #879fa0;\n      }\n\n      .cls-2 {\n        fill: #00bcb7;\n      }\n\n      .cls-3 {\n        fill: #1c1a18;\n      }\n\n      .cls-4 {\n        fill: #fff145;\n      }\n\n      .cls-5 {\n        fill: #9fbec1;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        fill: #ff4800;\n      }\n\n      .cls-8 {\n        fill: #d1c65d;\n      }\n\n      .cls-9 {\n        fill: aqua;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "193.41 192.6 107.51 192.6 41.88 211.35 33.37 300.8 267.56 300.8 259.04 211.35 193.41 192.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "41.88 211.35 33.37 300.8 47 300.8 50 226.73 41.88 211.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "40 228 106 238 106 183 0 183 40 228"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "259.99 211.55 268.5 301 254.87 301 251.87 226.93 259.99 211.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "161 291 151.16 296 141 291 111 212 191 212 161 291"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "260 228 194 238 194 183 300 183 260 228"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "202 242 152.16 262 101 242 61 178 151.71 158 242 178 202 242"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "162.57 238.91 150.74 242.45 138.91 238.91 116.1 204.85 51.04 166.41 108.2 132.61 185.49 132.61 250.44 166.41 185.38 204.85 162.57 238.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "233.28 41.67 229.05 34.07 170.12 70.65 132.14 70.65 73.01 34.29 68.78 41.9 74.99 101.09 51.46 164.49 107.92 160.83 130.64 163.03 141.12 215.79 161.14 215.79 171.45 163.03 193.64 160.83 250.8 164.49 227.62 101.04 233.28 41.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "193.19 162.75 171.02 164.72 174.96 146.01 209.88 141.84 193.19 162.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "151.16 224.48 141.2 215.52 151.16 212.32 161.12 215.52 151.16 224.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.94 162.97 131.12 164.94 127.17 146.22 94.79 142.05 108.94 162.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "68.78 43.9 74.66 102.23 95.82 84.45 68.78 43.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "233.28 43.67 227.4 102.01 206.24 84.23 233.28 43.67"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "161 118 150.46 128 141 118 137 69 165 69 161 118"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "57 160.78 35 150.78 35 109.78 57 99.78 57 160.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50 169.67 42 89.64 74 99.64 79 159.67 124.61 213.41 119 229 50 169.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "244 160.78 266 150.78 266 109.78 244 99.78 244 160.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "222 159.67 227 99.64 259 89.64 251 169.67 183 229 176.94 213.41 222 159.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "58 96 74 99.64 79 159.67 125 213 70 164 58 96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "82 138 63 122 20 13 63 34 101 69 82 138"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "227.09 57.35 151.33 89.35 72.57 57.35 62.57 40.78 150.69 6.35 237.09 40.78 227.09 57.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "242.67 95.92 226.67 99.56 221.67 159.58 177 213 230.67 163.92 242.67 95.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "218 138.35 238 123 280 13.35 237 34.35 199 69 218 138.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "227.09 48 151.33 80 72.57 48 62.57 34.43 150.69 0 237.09 34.43 227.09 48"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobTracerPilot);
export default __webpack_public_path__ + "static/media/mob-tracer-pilot.f093d517a61c87f29448fe41b0650647.svg";
export { ForwardRef as ReactComponent };